var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/articles", role: "button" }
              },
              [_vm._v("\n                    back\n                ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.article
        ? _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.createArticle.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.articleHead,
                              expression: "rules.articleHead"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Title",
                            placeholder: "Enter Article Title",
                            "data-vv-name": "Article Title",
                            "cus-name": "Article Title",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.article.articleHead,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "articleHead", $$v)
                            },
                            expression: "article.articleHead"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.imageUrl,
                              expression: "rules.imageUrl"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Image URL",
                            placeholder: "Enter Image URL",
                            "data-vv-name": "imageUrl",
                            "cus-name": "imageUrl",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.article.imageUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "imageUrl", $$v)
                            },
                            expression: "article.imageUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("label", [_vm._v("Published Date")]),
                        _vm._v(" "),
                        _c("datetime", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.datePublish,
                              expression: "rules.datePublish"
                            }
                          ],
                          attrs: {
                            required: "",
                            "input-class": "form-control",
                            label: "Published Date",
                            placeholder: "Select Date",
                            type: "date",
                            "input-format": "DD-MM-YYYY",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields,
                            "auto-continue": ""
                          },
                          model: {
                            value: _vm.article.datePublish,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "datePublish", $$v)
                            },
                            expression: "article.datePublish"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Author URL (Optional)",
                            placeholder: "Enter Author URL (Optional)",
                            "data-vv-name": "authorUrl",
                            "cus-name": "authorUrl"
                          },
                          model: {
                            value: _vm.article.authorUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "authorUrl", $$v)
                            },
                            expression: "article.authorUrl"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5" },
                      [
                        _c("fg-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.authorName,
                              expression: "rules.authorName"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Author Name",
                            placeholder: "Enter Author Name",
                            "data-vv-name": "authorName",
                            "cus-name": "authorName",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.article.authorName,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "authorName", $$v)
                            },
                            expression: "article.authorName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.paragraph1,
                              expression: "rules.paragraph1"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Paragraph 1",
                            placeholder: "Enter Paraghraph 1",
                            "data-vv-name": "paragraph1",
                            "cus-name": "paragraph1",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.article.paragraph1,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "paragraph1", $$v)
                            },
                            expression: "article.paragraph1"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.paragraph2,
                              expression: "rules.paragraph2"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Paragraph 2",
                            placeholder: "Enter Paragraph 2",
                            "data-vv-name": "paragraph2",
                            "cus-name": "paragraph2",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.article.paragraph2,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "paragraph2", $$v)
                            },
                            expression: "article.paragraph2"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.paragraph3,
                              expression: "rules.paragraph3"
                            }
                          ],
                          attrs: {
                            type: "text",
                            label: "Paragraph 3",
                            placeholder: "Enter Paraghraph 3",
                            "data-vv-name": "paragraph3",
                            "cus-name": "paragraph3",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields
                          },
                          model: {
                            value: _vm.article.paragraph3,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "paragraph3", $$v)
                            },
                            expression: "article.paragraph3"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-text-area", {
                          attrs: {
                            type: "text",
                            label: "Paragraph 4",
                            placeholder: "Enter Paraghraph 4",
                            "data-vv-name": "paragraph4",
                            "cus-name": "paragraph4"
                          },
                          model: {
                            value: _vm.article.paragraph4,
                            callback: function($$v) {
                              _vm.$set(_vm.article, "paragraph4", $$v)
                            },
                            expression: "article.paragraph4"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.showMore
                      ? _c("div", { staticClass: "col-12 text-center" }, [
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:" },
                              on: {
                                click: function($event) {
                                  _vm.showMore = true
                                }
                              }
                            },
                            [_vm._v("Add More Paragraphs?")]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("br")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showMore
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("fg-text-area", {
                              attrs: {
                                type: "text",
                                label: "Paragraph 5",
                                placeholder: "Enter Paraghraph 5",
                                "data-vv-name": "paragraph5",
                                "cus-name": "paragraph5"
                              },
                              model: {
                                value: _vm.article.paragraph5,
                                callback: function($$v) {
                                  _vm.$set(_vm.article, "paragraph5", $$v)
                                },
                                expression: "article.paragraph5"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showMore
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("fg-text-area", {
                              attrs: {
                                type: "text",
                                label: "Paragraph 6",
                                placeholder: "Enter Paraghraph 6",
                                "data-vv-name": "paragraph6",
                                "cus-name": "paragraph6"
                              },
                              model: {
                                value: _vm.article.paragraph6,
                                callback: function($$v) {
                                  _vm.$set(_vm.article, "paragraph6", $$v)
                                },
                                expression: "article.paragraph6"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showMore
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("fg-text-area", {
                              attrs: {
                                type: "text",
                                label: "Paragraph 7",
                                placeholder: "Enter Paraghraph 7",
                                "data-vv-name": "paragraph7",
                                "cus-name": "paragraph7"
                              },
                              model: {
                                value: _vm.article.paragraph7,
                                callback: function($$v) {
                                  _vm.$set(_vm.article, "paragraph7", $$v)
                                },
                                expression: "article.paragraph7"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showMore
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("fg-text-area", {
                              attrs: {
                                type: "text",
                                label: "Paragraph 8",
                                placeholder: "Enter Paraghraph 8",
                                "data-vv-name": "paragraph8",
                                "cus-name": "paragraph8"
                              },
                              model: {
                                value: _vm.article.paragraph8,
                                callback: function($$v) {
                                  _vm.$set(_vm.article, "paragraph8", $$v)
                                },
                                expression: "article.paragraph8"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showMore
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("fg-text-area", {
                              attrs: {
                                type: "text",
                                label: "Paragraph 9",
                                placeholder: "Enter Paraghraph 9",
                                "data-vv-name": "paragraph9",
                                "cus-name": "paragraph9"
                              },
                              model: {
                                value: _vm.article.paragraph9,
                                callback: function($$v) {
                                  _vm.$set(_vm.article, "paragraph9", $$v)
                                },
                                expression: "article.paragraph9"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showMore
                      ? _c(
                          "div",
                          { staticClass: "col-md-12" },
                          [
                            _c("fg-text-area", {
                              attrs: {
                                type: "text",
                                label: "Paragraph 10",
                                placeholder: "Enter Paraghraph 10",
                                "data-vv-name": "paragraph10",
                                "cus-name": "paragraph10"
                              },
                              model: {
                                value: _vm.article.paragraph10,
                                callback: function($$v) {
                                  _vm.$set(_vm.article, "paragraph10", $$v)
                                },
                                expression: "article.paragraph10"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: { type: "submit", disabled: _vm.errors.any() }
                    },
                    [
                      _vm._v(
                        "\n                        Create Article\n                    "
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Add Article")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1beeca98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1beeca98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Articles/CreateArticle.vue
// module id = AnpP
// module chunks = 0